import { HTTP, XIOS, HTTP_FORM } from './http-common'
import COOKIES from '@helpers/cookies'
import { isEmpty } from 'lodash'
import { vivazGeoloc } from './geoloc'

function getIntegrationType(data) {
  const integrationTypes = {
    'New-i': 'GuidCrm',
    'Sua house': 'IdSuaHouse',
    'Facilita': 'IdFacilita',
  }

  let integrationFounded = { Nome: 'Facilita' }
  if (
    !!data.TiposIntegracoes &&
    !isEmpty(data.TiposIntegracoes) &&
    +data.IdTipoIntegracaoLead
  ) {
    integrationFounded = data.TiposIntegracoes.find(
      integration => +integration.Id === data.IdTipoIntegracaoLead
    )
  }

  return integrationTypes[integrationFounded.Nome] || 'IdFacilita'
}

export default {

  async geolocation() {
    const { estados } = await this.getRegions()
    const userGeoLoc = await vivazGeoloc()

    // default to fallback location: SP
    const fallbackLocation = estados.find(({ Uf }) => (Uf.toLowerCase() === 'sp'))
    const foundLocation = userGeoLoc.success && estados.find(
      ({ Uf }) => (Uf.toLowerCase() === userGeoLoc.uf.toLowerCase())
    )
    const resultLocation = foundLocation || fallbackLocation

    // NOTE: API nova não consegue retornar mesma nomenclatura (casing) que a anterior
    const response = {
      'success': true,
      'msg': userGeoLoc.msg,
      // 'Ip': userGeoLoc.ip,
      'UF': resultLocation.Uf,
      'IdEstado': +resultLocation.IdEstado,
      'NomeEstado': resultLocation.Nome,
    }
    return response
  },

  contactUsCall(payload) {
    return new Promise((resolve, reject) => {
      return HTTP.post('/fale-conosco/ligamos-para-voce', payload).then((response) => {
        if (response.data.Success) {
          COOKIES.set(
            'whatsAppCookiesPersist',
            JSON.stringify({
              WhatsAppNumber: response.data.TelefoneContatoWhatsApp && response.data.TelefoneContatoWhatsApp.replace(/\D/g, ''),
              TipoGuidIntegracao: getIntegrationType(response.data),
            })
          )
          resolve(response.data)
        } else {
          reject(response.data)
        }
      })
    })
  },


  async getWhatsappNumberCyrelaApi(region, pdp, idImovel) {
    const payload = {
      ImovelOrigemId: 3,
      EstadoId: region,
      pdp: pdp,
      ImovelId: idImovel,
    }

    const queryParams = new URLSearchParams(payload).toString()
    const url = `https://rest.cyrela.com.br/apicyrela/api/Tarefas/whatsapp-number-rules?${queryParams}`

    try {
      const response = await fetch(url)

      if (response.ok) {
        const data = await response.json()
        return data
      } else {
        throw new Error('Erro ao buscar dados da API')
      }
    } catch (error) {
      throw error
    }
  },

  contactUsWhatsapp(payload) {
    return new Promise((resolve, reject) => {
      return HTTP.post('/fale-conosco/informacoes-por-whatsapp', payload).then((response) => {
        if (response.data.Success) {
          COOKIES.set(
            'whatsAppCookiesPersist',
            JSON.stringify({
              WhatsAppNumber: response.data.TelefoneContatoWhatsApp,
              TipoGuidIntegracao: getIntegrationType(response.data),
            })
          )
          resolve(response.data)
        } else {
          reject(response.data)
        }
      })
    })
  },

  contactUsChat(payload) {
    return new Promise((resolve, reject) => {
      return HTTP.post('/fale-conosco/chat', payload).then((response) => {
        if (response.data.Success) {
          COOKIES.set(
            'whatsAppCookiesPersist',
            JSON.stringify({
              WhatsAppNumber: response.data.TelefoneContatoWhatsApp,
              TipoGuidIntegracao: getIntegrationType(response.data),
            })
          )
          resolve(response.data)
        } else {
          reject(response.data)
        }
      })
    })
  },
  contactUsNeighbour(payload) {
    return HTTP_FORM.post('/webform_rest/submit', payload).then((response) => {
      return response.data
    })
  },
  contactUsWork(payload) {
    return XIOS.post('/fale-conosco/trabalhe-conosco', payload).then((response) => {
      return response.data
    })
  },
  contactMessage(payload) {
    return new Promise((resolve, reject) => {
      HTTP.post('/fale-conosco/informacoes-por-email', payload).then((response) => {
        if (response.data.Success) {
          COOKIES.set(
            'whatsAppCookiesPersist',
            JSON.stringify({
              WhatsAppNumber: response.data.TelefoneContatoWhatsApp,
              TipoGuidIntegracao: getIntegrationType(response.data),
            })
          )
          resolve(response.data)
        } else {
          reject(response.data)
        }
      }).catch((error) => {
        reject(error)
      })
    })
  },

  getPhoneNumber(region, productId = null) {
    return new Promise((resolve, reject) => {
      const payload = !!productId ? `${region}/${productId}` : region

      HTTP.get(`api/estado/telefoneVendasVivaz/IdEstado/${payload}`).then((response) => {
        if (response.data.success) {
          resolve(response.data)
        } else {
          reject(response.data)
        }
      })
        .catch((error) => {
          reject(error)
        })
    })
  },

  getPolicies(type) {
    return new Promise((resolve, reject) => {
      HTTP.get(`api/politica-privacidade/obter-topicos/3?tipo=${type}`).then((response) => {
        if (response.data) {
          resolve(response.data)
        } else {
          reject(response.data)
        }
      })
        .catch((error) => {
          reject(error)
        })
    })
  },

  subscribeNewsLetter(payload) {
    return new Promise((resolve, reject) => {
      HTTP.post('/fale-conosco/newsletter', payload).then((response) => {
        if (response.data.Success) {
          COOKIES.set(
            'whatsAppCookiesPersist',
            JSON.stringify({
              WhatsAppNumber: response.data.TelefoneContatoWhatsApp,
              TipoGuidIntegracao: getIntegrationType(response.data),
            })
          )
          resolve(response.data)
        } else {
          reject(response.data)
        }
      })
        .catch((error) => {
          reject(error)
        })
    })
  },

  getCities() {
    return new Promise((resolve, reject) => {
      HTTP.get('/simulador/cidades-recorte').then((response) => {
        if (response.data.success) {
          resolve(response.data.cidades)
        } else {
          reject(response.data)
        }
      })
        .catch((error) => {
          reject(error)
        })
    })
  },

  getRegions() {
    return new Promise((resolve, reject) => {
      HTTP.post('/api/estado/estadoshome', { IdImovelOrigem: 3 }).then((response) => {
        if (response.data.success) {
          resolve(response.data)
        } else {
          reject(response.data)
        }
      })
        .catch((error) => {
          reject(error)
        })
    })
  },

  getRegionsByCitySimulator(idCidade) {
    return new Promise((resolve, reject) => {
      HTTP.get(`/api/Estado/regioes-por-cidade/CidadeId/${idCidade}`).then((response) => {
        if (response.data.success) {
          resolve(response.data.regioes)
        } else {
          reject(response.data)
        }
      })
        .catch((error) => {
          reject(error)
        })
    })
  },

  getRegionsByCitySimple(idCidade) {
    return new Promise((resolve, reject) => {
      HTTP.get(`/api/Estado/regioes-por-cidade-simples/CidadeId/${idCidade}`).then((response) => {
        if (response.data.success) {
          resolve(response.data.regioes)
        } else {
          reject(response.data)
        }
      })
        .catch((error) => {
          reject(error)
        })
    })
  },

  simulatorCalc(payload) {
    return new Promise((resolve, reject) => {
      HTTP.post('/simulador/calcularV2', payload).then((response) => {
        if (response.data.Success) {
          COOKIES.set(
            'whatsAppCookiesPersist',
            JSON.stringify({
              WhatsAppNumber: response.data.TelefoneContatoWhatsApp,
              TipoGuidIntegracao: getIntegrationType(response.data),
            })
          )
          resolve(response.data)
        } else {
          reject(response.data)
        }
      })
        .catch((error) => {
          reject(error)
        })
    })
  },

  indicate(payload) {
    return new Promise((resolve, reject) => {
      HTTP.post('landingpage/indique-amigo-lp', payload).then((response) => {
        resolve(response.data)
      })
        .catch((error) => {
          reject(error)
        })
    })
  },

  getRegionBranches(idEstado, idImovel) {
    return new Promise((resolve, reject) => {
      HTTP.get(`/fale-conosco/buscar-filial?idEstado=${idEstado || ''}&idImovel=${idImovel || ''}`).then((response) => {
        if (response.data.sucess) {
          resolve(response.data)
        } else if (!response.data.sucess) {
          resolve(response.data.msg)
        }
      })
        .catch((error) => {
          reject(error)
        })
    })
  },

  getBranchesByCoords(latitude, longitude) {
    return new Promise((resolve, reject) => {
      HTTP.get(`/api/filiais/listar-por-coordenadas?latitude=${latitude}&longitude=${longitude}`).then((response) => {
        if (response.data.success) {
          resolve(response.data)
        } else {
          reject(response.data)
        }
      }).catch((error) => {
        reject(error)
      })
    })
  },

  getBranchesByRegion(regionId) {
    return new Promise((resolve, reject) => {
      HTTP.get(`/api/filiais/listar-por-regiao/idRegiao/${regionId}`).then((response) => {
        if (response.data.success) {
          resolve(response.data)
        } else {
          reject(response.data)
        }
      }).catch((error) => {
        reject(error)
      })
    })
  },

  getItemsByTermFromSearchBar(term, grantedGeolocation) {
    const stateId = grantedGeolocation && localStorage.getItem('storedRegion') ?
      localStorage.getItem('storedRegion') : false

    return new Promise((resolve, reject) => {
      const payload = `IdImovelOrigem=3&Termo=${term}&Pagina=1${stateId ? `&IdEstado=${stateId}` : ''}`
      HTTP.post(`https://rest.cyrela.com.br/apicyrela/api/Busca/cloud-search?${payload}`).then(response => {
        if (response.data) {
          resolve(response.data)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },

  recordLog(payload) {
    return new Promise((resolve, reject) => {
      HTTP.post('/log/grava-log-integracao', payload).then((response) => {

        if (response.data.success) {
          resolve(response.data)
        } else {
          reject(response.data)
        }
      })
        .catch((error) => {
          reject(error)
        })
    })
  },

  callFacilita(payload) {
    return new Promise((resolve, reject) => {
      HTTP.post('https://vivazsp.api.facilitavendas.com/public/trackerform', payload).then((response) => {
        if (response.status) {
          if (response.status === 'success') {
            resolve(response.status)
          }
          if (response.status === 'error') {
            reject(response.status)
          }
        }
      })
        .catch((error) => {
          reject(error)
        })
    })
  },


  submitSimuladorForm(payload) {

    let urlAPI = 'https://blipnotificationsender.azurewebsites.net/api/user/state'

    const headers = {
      'Content-Type': 'application/json',
      'Authorization': 'Basic',
    }

    const payloadObj = JSON.parse(payload)

    const corpoRequisicao = {
      routerBotKey: 'dml2YXpzaW11bGFkb3I6c0p1V1VZb3lWbVpjN3pSMkhHNUo=',
      botKey: 'dml2YXpzaW11bGFkb3IxOlZJNk1XUmh6UThkbHdmSFljRUlW',
      botSlug: 'vivazsimulador1',
      phone: payloadObj.numero,
      namespace: '71879451_3e59_4e4a_81bb_6a5a1f57469d',
      templateName: 'simulador_vivaz',
      parameters: [
        {
          componentType: 'body',
          type: 'text',
          text: payloadObj.nome,
        },
      ],
      stateId: 'onboarding',
      flowId: '459cc89f-6d0b-4c16-af9c-b8934c37ef75',
      contactExtras: {
        name: payloadObj.nome,
        numero: payloadObj.numero,
        urlCampanha: payloadObj.urlCampanha,
        produto: payloadObj.produto,
      },
    }

    return new Promise((resolve, reject) => {
      HTTP.post(
        urlAPI,
        corpoRequisicao,
        { headers }
      )

        .then((response) => {
          resolve(response.data.status)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
}



// WEBPACK FOOTER //
// ./src/api/shared.js